import clsx from 'clsx';
import React from 'react';
import { DsmColor } from '../../constants/colors.mjs';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import { Typography } from '../../Foundations/Typography/Typography.mjs';
import { Flex } from '../../Layout/Flex/Flex.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import classes from './Tab.module.css.mjs';
import { tabTypeClasses } from './Tab.utils.mjs';

const Tab = polymorphicFactory(
  (props, ref) => {
    const { text, component = "button", isSelected = false, variant = "horizontal", icon, className, ...rest } = props;
    const isHorizontal = variant === "horizontal";
    return /* @__PURE__ */ React.createElement(Flex, { direction: isHorizontal ? "column" : "row", gap: isHorizontal ? 5 : void 0, align: "center" }, !isHorizontal && /* @__PURE__ */ React.createElement(Box, { backgroundColor: isSelected ? DsmColor.BorderPrimary : "transparent", width: 3, style: { flexShrink: 0 } }), isHorizontal && icon ? /* @__PURE__ */ React.createElement(React.Fragment, null, icon) : null, /* @__PURE__ */ React.createElement(
      Typography,
      {
        component,
        size: isHorizontal ? "label-medium-l" : "label-medium-m",
        type: component === "button" ? "button" : void 0,
        className: clsx(classes.tab, className, tabTypeClasses[variant], "kohler-tab-root"),
        textColor: rest["aria-expanded"] || isSelected ? DsmColor.ContentPrimary : DsmColor.ContentTertiary,
        cursor: "pointer",
        ref,
        ...rest
      },
      text
    ), isSelected && isHorizontal && /* @__PURE__ */ React.createElement(Box, { height: 4, backgroundColor: DsmColor.BorderPrimary, className: classes.horizontalTabBar }));
  }
);

export { Tab };
